import { createSlice } from '@reduxjs/toolkit';

const options = {
  name: 'layout',
  initialState: {
    isCookiePreferencesOpen: false,
    isCookieBannerOpen: false,
    alertMessage: {
      text: '',
      type: '',
    },
  },
  reducers: {
    openCookiePreferences: (state) => ({ ...state, isCookiePreferencesOpen: true }),
    closeCookiePreferences: (state) => ({ ...state, isCookiePreferencesOpen: false }),
    openCookieBanner: (state) => ({ ...state, isCookieBannerOpen: true }),
    closeCookieBanner: (state) => ({ ...state, isCookieBannerOpen: false }),
    setAlertMessage: (state, action) => ({ ...state, alertMessage: action.payload }),
    cleanAlertMessage: (state) => ({ ...state, alertMessage: { text: '', type: '' } }),
  },
};
const layoutSlice = createSlice(options);

export const selectAlertMessage = (state) => state.layout.alertMessage;
export const { openCookiePreferences, closeCookiePreferences, openCookieBanner, closeCookieBanner, setAlertMessage, cleanAlertMessage } = layoutSlice.actions;
export default layoutSlice.reducer;
